export enum CallingHolidayRule {
  NONE = "NONE",
  FEDERAL = "FEDERAL",
  STATE = "STATE",
  STATE_AND_FEDERAL = "STATE_AND_FEDERAL",
}
